/**
 * Shared constants for the RelayYardControl feature.
 * Importable by both feature-level code (store, hooks) and page-level code (handlers, components).
 */

/**
 * Prefix used for dynamic seal edit fields (actualSeals_0, actualSeals_1, etc.).
 * Used by TrailerDetailsSection.Editable to build field names and by save handlers
 * + Redux slice to detect and extract seal changes.
 */
export const SEAL_FIELD_PREFIX = "actualSeals_";
